import { h } from "preact";
import { RoutableProps } from "preact-router";
import { useEffect, useState } from "preact/hooks";
import { createProductType, editProductType, getProductType } from "../../../api/product-api";
import { useCommand } from "../../../hooks";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { route } from "../../../App";

export function ProductTypeNew(props: RoutableProps & { id?: string }) {
    const [originalName, setOriginalName] = useState("");
    const [name, setName] = useState("");
    const [brand, setBrand] = useState("");
    const [serialNumberType, setSerialNumberType] = useState("serial-8-base32");
    const [description, setDescription] = useState("");
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();

    useEffect(() => {
        if (!props.id) {
            return;
        }

        getProductType(+props.id).then((productType) => {
            setOriginalName(productType.name);
            setName(productType.name);
            setBrand(productType.brand);
            setSerialNumberType(productType.serialNumberType?.name || "serial-8-base32");
            setDescription(productType.description || "");
        });
    }, []);

    return <div class="p-4 max-w-7xl self-center w-full">
        <Snackbar doShow={showSnackbarCommand}/>
        <h1>{props.id ? `Edycja produktu '${originalName}'` : "Dodaj nowy rodzaj produktu"}</h1>
        <form>
            <div class="paper p-4 flex flex-col">
                <div class="grid grid-cols-[auto_auto] gap-2 self-start">
                    <label>Nazwa rodzaju produktu</label>
                    <input class="ml-2" required onChange={(e) => setName(e.currentTarget.value)} value={name}/>
                    <label>Branding rodzaju produktu (po angielsku)</label>
                    <input class="ml-2" required size={40} onChange={(e) => setBrand(e.currentTarget.value)} value={brand}/>
                    <label>Rodzaj numeru seryjnego</label>
                    <select class="ml-2" required onChange={(e) => setSerialNumberType(e.currentTarget.value)} value={serialNumberType}>
                        <option>serial-8-base32</option>
                        <option>serial-6-base16</option>
                        <option>gtin-lot-8-date</option>
                    </select>
                    <label>Opis rodzaju produktu</label>
                    <textarea class="ml-2" rows={4} cols={40} onChange={(e) => setDescription(e.currentTarget.value)} value={description}/>
                </div>
                <div class="flex mt-4">
                    <button class={!name || !brand || !serialNumberType ? "disabled" : ""} type="submit" disabled={!name || !brand || !serialNumberType} onClick={(e) => {
                        e.preventDefault();

                        if (props.id) {
                            editProductType({
                                id: +props.id,
                                name,
                                brand,
                                serialNumberType,
                                description
                            }).then(() => {
                                showSnackbarCommand.run("Rodzaj produktu został zaktualizowany", 'success');
                                route("/product-type/" + props.id);
                            }).catch((e) => {
                                showSnackbarCommand.run("Nie udało się zaktualizować rodzaju produktu: " + e.message, 'error');
                            });
                        } else {
                            createProductType({
                                name,
                                brand,
                                serialNumberType,
                                description
                            }).then(v => {
                                showSnackbarCommand.run(`Rodzaj produktu '${name}' został utworzony`, 'success');
                                route("/product-type/" + v.id);
                            }).catch((e) => {
                                showSnackbarCommand.run("Nie udało się utworzyć rodzaju produktu: " + e.message, 'error');
                            });
                        }
                    }}>{props.id ? "Zapisz" : "Utwórz"}</button>
                </div>
            </div>
        </form>
    </div>;
}
